import { productsData } from '../data/data'

// Slug-friendly version of a string (lowercase, no accents, dashes)
export const slugify = (str) =>
    str
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')

// Build a unique stable id for a product: "<categoryId>-<product-slug>"
export const buildProductId = (categoryId, productName) =>
    `${categoryId}-${slugify(productName)}`

// Returns a flat list of all products enriched with: id, categoryId, categoryName
export const getAllProducts = () => {
    const list = []
    productsData.categories.forEach((category) => {
        category.products.forEach((product) => {
            list.push({
                ...product,
                id: buildProductId(category.id, product.name),
                categoryId: category.id,
                categoryName: category.name,
                // Les catégories non alimentaires (matériel, intrants) déclarent bio: false
                bio: category.bio !== false,
            })
        })
    })
    return list
}

// Find a single product by its slug-id
export const findProductById = (id) =>
    getAllProducts().find((p) => p.id === id) || null
